import "./TabNotificationIndicator.css";

export const TabNotificationIndicator = (): JSX.Element => {
  return (
    <div className="TabNotificationContainer">
      <div className="TabNotificationIndicator" />
    </div>
  );
};
